import { render, staticRenderFns } from "./pro-detail-calendar.vue?vue&type=template&id=2d0b4bd4&scoped=true&"
import script from "./pro-detail-calendar.vue?vue&type=script&lang=js&"
export * from "./pro-detail-calendar.vue?vue&type=script&lang=js&"
import style0 from "./pro-detail-calendar.vue?vue&type=style&index=0&id=2d0b4bd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b4bd4",
  null
  
)

export default component.exports